import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { isNullOrUndefined } from 'util';

@Injectable()
export class DespachoAtenderService {

  apiService: any;

  constructor() { }

  atender(vm, dados) {
    let dataValida
    let dadosUltimoAndamento
    dados.data_andamento = vm.dataHoraDoSistema;

    if (dados.providenciaRealizada == ' ' || dados.data_inicio == ' ' || dados.data_fim == ' ') {
      vm.toastr.warning('Existem Campos que não foram preenchidos - Cadastro não finalizado', 'Atenção');
      return false

    } else {
      dataValida = this.validaDataInicioDataFim(vm, dados);
      dadosUltimoAndamento = this.recuperaDadosDoUltimoAndamento(vm, dados)
      if (dataValida) {
        return true;
      }
    }
  }

  validaDataInicioDataFim(vm, dados) {

    dados.data_inicio = vm.pipe.transform(dados.data_inicio);
    dados.data_fim = vm.pipe.transform(dados.data_fim);

    if (vm.data_hora_help.data1EhMaiorQueData2(dados.data_inicio, dados.data_fim)) {
      vm.toastr.warning('Por favor a data fim não pode ser anterior a data do início. - Cadastro não finalizado', 'Atenção');
      vm.exibirSpinnerListaDeAndamento = false;

      return false
    } else {

      return true
    }
  }

  recuperaDadosDoUltimoAndamento(vm, dados) {

    if (vm.andamentos.length > 0) {
      let i = vm.andamentos.length - 1
      if (!isNullOrUndefined(vm.andamentos[i].agente)) {
        dados.matricula = vm.andamentos[i].agente.matricula;
        dados.agentes_id = vm.andamentos[i].agentes_id;
        dados.user_id = vm.andamentos[i].agente.user_id;
        dados.agente_nome = vm.andamentos[i].agente_nome
        dados.unidades_id = vm.andamentos[i].unidades_id;

      } else { // Atendimento realizado pela Unidade
        dados.matricula = '';
        dados.agentes_id = '';
        dados.user_id = '';
        dados.agente_nome = '';
        dados.unidades_id = vm.andamentos[i].unidades_id;
        dados.unidades_nome = vm.andamentos[i].unidades_nome;
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/services/despachoAtender.service.ts